import { render, staticRenderFns } from "./IpsDropdown.vue?vue&type=template&id=fa045d1c&scoped=true"
import script from "./IpsDropdown.vue?vue&type=script&lang=js"
export * from "./IpsDropdown.vue?vue&type=script&lang=js"
import style0 from "./IpsDropdown.vue?vue&type=style&index=0&id=fa045d1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa045d1c",
  null
  
)

export default component.exports